import { t } from 'i18next';

import type { ICommonDataType } from '@common/types';

export const actionField = (width: number = 100): ICommonDataType => ({
  title: t('table.actions'),
  concealable: false,
  key: 'operation',
  fixed: 'right',
  align: 'center',
  width,
});
